var searchFormInit;

(function ($) {

	const selectors = {
		form: '[data-search-form]',
		clearCheckbox: '[data-clear-filters]',
	}


	searchFormInit = function () {
		$(selectors.form).each((i, el) => {
			new SearchForm(el);
		});
	}

	class SearchForm {
		constructor(element) {
			this.$form = $(element);

			if (this.$form.length) {
				this.init();
			}

		}
		init() {

			this.$clearCheckbox = $(selectors.clearCheckbox, this.$form);

			this.bind();
		}

		bind() {
			this.clearFilters = this.clearFilters.bind(this);
			this.$clearCheckbox.on('change', this.clearFilters);
		}

		clearFilters() {
			// this.$clearCheckbox.prop('checked', false);

			$('[type="checkbox"]', this.$form).each((i, el) => {
				$(el).prop('checked', false);
			});

			$('select', this.$form).each((i, el) => {
				$(el).find('option[value=""]').prop('selected', true);
				$(el).trigger('change');
			});

			$('.noUi-target', this.$form).each((i, el) => {
				el.noUiSlider.set([el.noUiSlider.options.range.min, el.noUiSlider.options.range.max]);
			});

		}

	}

})(jQuery);


export default searchFormInit;